/* eslint-disable */
import React from 'react';
import classNames from 'classnames';

export default function Option({
	group_index,
	value,
	doesExist,
	isInStock,
	setFilter,
	setFilters,
	selected
}) {
	const available = doesExist && isInStock;

	const rootClassnames = classNames({
		[`pdp-form__option`]: true,
		// ['disabled']: !available,
		['selected']: selected,
		['doesNotExist']: !doesExist,
		['notInStock']: !isInStock,
	});

	function handleClick(){
		//	Do nothing if it's already selected.
		if (selected) {
			return;
		}

		setFilter(group_index,selected?null:value);
	};

	return (
		<button
			className={rootClassnames}
			onClick={handleClick}
		>
				{value.split(' - ').length === 1 ? value : value.split(' - ')[0]}

				{value.split(' - ')[1] && (
					<span>{value.split(' - ')[1]}</span>
				)}

		</button>
	);

}//function
